<script setup lang="ts">
/**
 * Logo oficial da Microsoft (quatro quadrados coloridos) em SVG inline.
 *
 * @example
 * ```vue
 * <MicrosoftLogo />
 * ```
 */
</script>

<template>
  <svg
    class="microsoft-logo"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/200/svg"
    role="img"
    aria-label="Microsoft"
  >
    <rect x="1" y="1" width="10" height="10" fill="#F25022" />
    <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
    <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
    <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
  </svg>
</template>


<style scoped>
.microsoft-logo {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: block;
}
</style>